import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useGetJobQuery } from '../job/jobEndpoints';

/** The longest a job's request is shown as the link text before being cut with an ellipsis. */
const REQUEST_MAX = 60;

/** Props for `TaskJobLink`. */
export interface TaskJobLinkProps {
  jobId: string;
}

/**
 * Names the job that drafted a task, linking to it (QZ-D59, QZ-D60). No polling: a job's
 * title does not change once set, so a one-off fetch is enough.
 */
export const TaskJobLink = ({ jobId }: TaskJobLinkProps) => {
  const { t } = useTranslation();
  const { currentData: job } = useGetJobQuery(jobId);

  const request = job?.request ?? '';
  const label = job
    ? (job.title ?? (request.length <= REQUEST_MAX ? request : `${request.slice(0, REQUEST_MAX)}…`))
    : jobId.slice(0, 8);

  // `task.page.fromJob` is "from job {{title}}"; splitting on a marker keeps the link where
  // `{{title}}` would render, instead of baking the whole sentence into the link text.
  const [before, after = ''] = t('task.page.fromJob', { title: '\u0000' }).split('\u0000');

  return (
    <span className="qz-small qz-muted">
      · {before}
      <Link to={`/jobs/${jobId}`}>{label}</Link>
      {after}
    </span>
  );
};

export default TaskJobLink;
